{
  "title": "Create or Destroy Water",
  "source": "Player's Handbook",
  "levelAndSchool": "1st-level transmutation",
  "level": 1,
  "castingTime": "1 action",
  "range": "30 feet",
  "components": "V, S, M (a drop of water if creating water or a few grains of sand if destroying it)",
  "duration": "Instantaneous",
  "description": [
    "You either create or destroy water.",
    "Create Water. You create up to 10 gallons of clean water within range in an open container. Alternatively, the water falls as rain in a 30-foot cube within range, extinguishing exposed flames in the area.",
    "Destroy Water. You destroy up to 10 gallons of water in an open container within range. Alternatively, you destroy fog in a 30-foot cube within range.",
    "At Higher Levels. When you cast this spell using a spell slot of 2nd level or higher, you create or destroy 10 additional gallons of water, or the size of the cube increases by 5 feet, for each slot level above 1st."
  ],
  "spellLists": ["cleric", "druid"]
}
